/* Pellet Diretto theme */
(function () {
  'use strict';

  // Menu mobile
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('.visually-hidden').textContent = open ? 'Chiudi menu' : 'Apri menu';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  // Quantità
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v + parseInt(btn.dataset.qty, 10));
    });
  });

  // Galleria prodotto
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = thumb.dataset.thumb;
        gallery.querySelectorAll('[data-slide]').forEach(function (s) {
          s.classList.toggle('is-active', s.dataset.slide === i);
        });
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  // Calcolatore pellet
  var finder = document.querySelector('[data-finder]');
  if (finder) {
    var section = finder.closest('.finder');
    var products = [];
    try { products = JSON.parse(section.querySelector('[data-finder-products]').textContent) || []; } catch (e) {}

    // Giorni di accensione per stagione, per zona climatica
    var NORD = ["Valle d'Aosta", 'Piemonte', 'Lombardia', 'Trentino-Alto Adige', 'Veneto', 'Friuli Venezia Giulia', 'Emilia-Romagna'];
    var SUD = ['Campania', 'Puglia', 'Basilicata', 'Calabria', 'Sicilia', 'Sardegna'];
    var CARICO = 0.6;      // potenza media usata rispetto alla nominale
    var KWH_PER_KG = 4.8;  // pellet ENplus A1
    var RENDIMENTO = 0.9;
    var KG_SACCO = 15;
    var euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

    var el = {
      regione: finder.querySelector('[data-regione]'),
      kw: finder.querySelector('[data-kw-in]'),
      kwOut: finder.querySelector('[data-kw-out]'),
      ore: finder.querySelector('[data-ore]'),
      oreOut: finder.querySelector('[data-ore-out]'),
      sacchi: section.querySelector('[data-sacchi]'),
      giorni: section.querySelector('[data-giorni]'),
      bancali: section.querySelector('[data-bancali-msg]'),
      pick: section.querySelector('[data-pick]'),
      pickLink: section.querySelector('[data-pick-link]'),
      pickTitle: section.querySelector('[data-pick-title]'),
      pickFacts: section.querySelector('[data-pick-facts]')
    };

    function update() {
      var kw = parseFloat(el.kw.value);
      var ore = parseFloat(el.ore.value);
      var regione = el.regione.value;
      var giorni = NORD.indexOf(regione) > -1 ? 180 : SUD.indexOf(regione) > -1 ? 120 : 150;
      var kg = kw * ore * giorni * CARICO / (KWH_PER_KG * RENDIMENTO);
      var sacchi = Math.ceil(kg / KG_SACCO);

      el.kwOut.textContent = kw + ' kW';
      el.oreOut.textContent = ore + ' ore';
      el.sacchi.textContent = sacchi;
      el.giorni.textContent = giorni;
      el.bancali.textContent = 'Circa ' + String(Math.round(sacchi / 70 * 10) / 10).replace('.', ',') +
        ' bancali da 70 sacchi, ' + Math.round(kg).toLocaleString('it-IT') + ' kg di pellet.';

      // Il formato che copre il fabbisogno al prezzo più basso
      var best = null;
      products.forEach(function (p) {
        var qty = Math.ceil(sacchi / p.sacchi);
        var cost = qty * p.price;
        if (!best || cost < best.cost) best = { p: p, qty: qty, cost: cost };
      });
      if (!best) { el.pick.hidden = true; return; }
      el.pick.hidden = false;
      el.pickLink.href = best.p.url;
      el.pickTitle.textContent = (best.qty > 1 ? best.qty + ' × ' : '') + best.p.title;
      el.pickFacts.textContent = best.qty * best.p.sacchi + ' sacchi, ' + euro.format(best.cost / 100);
    }

    finder.addEventListener('input', update);
    finder.addEventListener('change', update);
    update();
  }
})();
